import { render, staticRenderFns } from "./ClaimManagement.vue?vue&type=template&id=75c444e4&scoped=true"
import script from "./ClaimManagement.vue?vue&type=script&lang=js"
export * from "./ClaimManagement.vue?vue&type=script&lang=js"
import style0 from "./ClaimManagement.vue?vue&type=style&index=0&id=75c444e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c444e4",
  null
  
)

export default component.exports